import { useState } from "react";
import { createTaskType } from "../../api";

// ============================================================================
// Inline form for the New Task Type quick-add modal.
// ============================================================================
export default function NewTaskTypeForm({ onCancel, onSaved }) {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setErr("Name required");
      return;
    }
    setBusy(true);
    setErr("");
    try {
      const payload = { name: name.trim() };
      if (category) payload.default_category = category;
      const created = await createTaskType(payload);
      onSaved(created);
    } catch (e2) {
      setErr(e2?.message || "Failed to create");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <div style={{ marginBottom: 12 }}>
        <label
          style={{
            display: "block",
            fontSize: 12,
            color: "#374151",
            marginBottom: 4,
          }}
        >
          Name
        </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
          style={{
            width: "100%",
            padding: "6px 8px",
            border: "1px solid #d1d5db",
            borderRadius: 4,
            boxSizing: "border-box",
          }}
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label
          style={{
            display: "block",
            fontSize: 12,
            color: "#374151",
            marginBottom: 4,
          }}
        >
          Default Category
        </label>
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{
            width: "100%",
            padding: "6px 8px",
            border: "1px solid #d1d5db",
            borderRadius: 4,
            boxSizing: "border-box",
            background: "white",
          }}
        >
          <option value="">Either</option>
          <option value="corporate">Corporate (T2)</option>
          <option value="personal">Personal (T1)</option>
        </select>
      </div>
      {err && (
        <div style={{ color: "#dc2626", marginBottom: 8, fontSize: 13 }}>
          {err}
        </div>
      )}
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button
          type="button"
          onClick={onCancel}
          disabled={busy}
          style={{
            padding: "6px 12px",
            border: "1px solid #d1d5db",
            borderRadius: 4,
            background: "white",
            cursor: busy ? "not-allowed" : "pointer",
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={busy}
          style={{
            padding: "6px 12px",
            border: "none",
            borderRadius: 4,
            background: "#059669",
            color: "white",
            cursor: busy ? "not-allowed" : "pointer",
          }}
        >
          {busy ? "Saving…" : "Save"}
        </button>
      </div>
    </form>
  );
}
